module.exports = __webpack_public_path__ + "static/speed-1@2x-1a0c33bb24c72a95812004a1c2b16425.png";